export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6219.f029c3c6.jpg";